import { InboxAPI } from 'api';
import { useQuery } from '@tanstack/react-query';

/**
 * Backs both the inbox tab badges and the Topbar bell. Polled every minute
 * plus refetched on window focus, since this mounts for every user on every
 * route (not just while the inbox itself is open).
 *
 * `enabled` is not optional in practice for the Topbar. `/api/v1/inbox/counts`
 * is restricted server-side to administrators, coordinators and supervisors,
 * and the Topbar mounts on every route for every user — so leaving it on for a
 * technician means a rejected request once a minute for their whole session.
 * Callers that only conditionally render the badge must gate the fetch too;
 * hiding the bell does not stop the polling.
 */
export function useInboxCounts(enabled = true) {
  return useQuery(['inbox-counts'], InboxAPI.getInboxCounts, {
    enabled,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
